import { motion } from 'framer-motion/dist/framer-motion'
import { Link } from 'react-router-dom'

const MotionLink = motion(Link)

export default MotionLink